import { render, staticRenderFns } from "./BatchList.vue?vue&type=template&id=774e0f53&scoped=true&"
import script from "./BatchList.vue?vue&type=script&lang=ts&"
export * from "./BatchList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774e0f53",
  null
  
)

export default component.exports